import React from 'react'
import { Link } from 'react-router-dom'
import { Typography, Tabs, Row, Col, Button, Input, Select, Spin, Form } from 'antd'
import { Queries } from '../../../../graphql'
import { withApollo } from 'react-apollo'
import Container from '../../../../components/user/Container'
import Switchbox from '../../../../components/user/from/Switchbox'
import ViewDraftMeeting from '../../../../components/user/from/MeetingManagement/ViewDraftMeeting'
import ViewInviteMeeting from '../../../../components/user/from/MeetingManagement/ViewInviteMeeting'
import SentNoteApproveMeeting from '../../../../components/user/from/MeetingManagement/SentNoteApproveMeeting'
import { UrlMeeting } from '../../../../utils/auth'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../../components/user/ModalErrors'
import axios from 'axios';
import axiosAPI, { urlAttachFile } from "../../../../config/axiosAPI";


const { Option } = Select;
const { Search } = Input;
const { TabPane } = Tabs;
const { Text, Title } = Typography

class InviteMeeting extends React.Component {

    state = {
        dataMeeting: [],
        textInvite: "",
        typeInvite: "",
        loadingScreen: false,
    }

    componentDidMount = () => {
        this.fetchDataMeeting();
    }
    fetchDataMeeting = () => {
        this.setState({ loadingScreen: true });
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/listmeetinginvited`,
            {
                UserID: sessionStorage.getItem('username'),
                MeetingName: this.state.textInvite,
                OptionSearch: this.state.typeInvite,
            })
            .then(response => {
               console.log("responsresponsee", response)
                const data = response.data.data
                this.setState({
                    dataMeeting: data ? data : [],
                    loadingScreen: false,
                })
            }).catch(error => {
                this.setState({ loadingScreen: false, })
                console.error(`Error: ${error}`)
            })

    }
    onChangeSearchInvite = (value) => {
        this.setState({ loadingScreen: true });
        console.log("valuevaluevaluevalue", value)
        this.setState({
            textInvite: value.target.value
        })
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/listmeetinginvited`,
            {
                UserID: sessionStorage.getItem('username'),
                MeetingName: value.target.value,
                OptionSearch: this.state.typeInvite,
            })
            .then(response => {
                const data = response.data.data
                this.setState({
                    dataMeeting: data ? data : [],
                    loadingScreen: false,
                })
                // console.log("listmeetinginvited", data);
            }).catch(error => {
                this.setState({ loadingScreen: false, })
                console.error(`Error: ${error}`)
            })
    }

    onChangeType = (value) => {
        // console.log("value", value);
        this.setState({ loadingScreen: true });
        this.setState({
            typeInvite: value
        })
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/listmeetinginvited`,
            {
                UserID: sessionStorage.getItem('username'),
                MeetingName: this.state.textInvite,
                OptionSearch: value,
            })
            .then(response => {
                const data = response.data.data
                this.setState({
                    dataMeeting: data ? data : [],
                    loadingScreen: false,
                })
                // console.log("listmeetinginvited", data);
            }).catch(error => {
                this.setState({ loadingScreen: false, })
                console.error(`Error: ${error}`)
            })
    }

    handleSubmit = (e) =>{
      // console.log("value", value);
      this.setState({ loadingScreen: true });
     
      axiosAPI.post(`${UrlMeeting()}/meeting/secure/listmeetinginvited`,
          {
              UserID: sessionStorage.getItem('username'),
              MeetingName: this.state.textInvite,
              OptionSearch: this.state.typeInvite,
          })
          .then(response => {
              const data = response.data.data
              this.setState({
                  dataMeeting: data ? data : [],
                  loadingScreen: false,
              })
              // console.log("listmeetinginvited", data);
          }).catch(error => {
              this.setState({ loadingScreen: false, })
              console.error(`Error: ${error}`)
          })
    }

    clickAccept = (id, type, note) => {
        this.setState({ loadingScreen: true });
        if (type == "JOIN") {
            axiosAPI.post(`${UrlMeeting()}/meeting/secure/acceptanceMeeting`,
                {
                    UserID: sessionStorage.getItem('username'),
                    MeetingID: id,
                    Status: "JOIN",
                    Delegate: {
                    }
                })
                .then(response => {
                    this.setState({ loadingScreen: false })
                    this.fetchDataMeeting();
                }).catch(error => {
                    this.setState({ loadingScreen: false, })
                    console.error(`Error: ${error}`)
                })
        }
        else if (type == "REFUSE") {
            axiosAPI.post(`${UrlMeeting()}/meeting/secure/acceptanceMeeting`,
                {
                    UserID: sessionStorage.getItem('username'),
                    MeetingID: id,
                    Status: "REJECT",
                    Delegate: {
                    }
                })
                .then(response => {
                    this.setState({ loadingScreen: false })
                    this.fetchDataMeeting();
                }).catch(error => {
                    this.setState({ loadingScreen: false, })
                    console.error(`Error: ${error}`)
                })
        }
        else {
            axiosAPI.post(`${UrlMeeting()}/meeting/secure/acceptanceMeeting`,
                {
                    UserID: sessionStorage.getItem('username'),
                    MeetingID: id,
                    Status: "DELEGATE",
                    Delegate: type,
                    note
                })
                .then(response => {
                    this.setState({ loadingScreen: false })
                    this.fetchDataMeeting();
                }).catch(error => {
                    this.setState({ loadingScreen: false, })
                    console.error(`Error: ${error}`)
                })
        }
    }

   

    render() {
        const { match } = this.props
        
         console.log("dataMeeting", this.state.dataMeeting)
        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <Spin tip="Loading..." size="large" spinning={this.state.loadingScreen} style={{ alignItems: 'center', position: 'initial' }}>
                    <div className="card-container meeting-management" id="create-meeting">
                        <div className="p-5 card-bg-white">
                              <Row gutter={16} className={'py-4 mr-0 ml-0'}>
                                 <Col xs={24} lg={12}>
                                    <Input
                                       // prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                       onBlur={this.onChangeSearchInvite}
                                       style={{ width: '100%' }}
                                       placeholder="ค้นหา"
                                    />
                                 </Col>
                                 <Col xs={24} md={12} lg={7} >
                                       <Select
                                          showSearch
                                          defaultValue=""
                                          style={{ width: '100%' }}
                                          optionFilterProp="children"
                                          onChange={this.onChangeType}
                                          filterOption={(input, option) =>
                                             option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                          }
                                       >
                                          <Option value="" >ทั้งหมด</Option>
                                          <Option value="WAITING">รอดำเนินการ</Option>
                                          <Option value="JOIN">ตอบรับ</Option>
                                          <Option value="REFUSE">ปฏิเสธ</Option>
                                          <Option value="AGENT">ส่งตัวแทน</Option>
                                       </Select>
                                 </Col>
                                 <Col xs={24} md={12} lg={5} >
                                       <Button 
                                          className={'button-meeting-search mt-3 mt-lg-0'}  
                                          type="primary" 
                                          htmlType="submit"
                                          onClick={() => this.handleSubmit()}
                                       >
                                          ค้นหา
                                       </Button>
                                 </Col>
                              </Row>
                            <div style={{ height: 650, width: '100%', overflow: "auto" }}>
                                <ViewInviteMeeting dataMeeting={this.state.dataMeeting} clickAccept={this.clickAccept}></ViewInviteMeeting>
                            </div>
                        </div>
                    </div>
                </Spin>
            </Container >
        )
    }
}

InviteMeeting.propTypes = {
    //
}

export default withApollo(InviteMeeting)